import { React,  DomeManipulator } from '@lexriver/dome'
import css from './ErrorForInput.m.scss'
import cssAnimation from '../../Animation.m.scss'
import {DomeComponent} from '@lexriver/dome'
import { DataTypes } from '@lexriver/data-types'
import { Async } from '@lexriver/async'


interface Attrs{
    //text:string
}

export class ErrorForInput extends DomeComponent<Attrs>{
    protected readonly divContainer:HTMLDivElement = <div class={css.tooltip}></div>
    protected readonly spanErrorMessage:HTMLSpanElement = <span></span>
    protected readonly spanArrow = <span class={css.tooltipArrow}></span>
    protected isVisible:boolean = false

    protected render(){
        this.divContainer.appendChild(this.spanErrorMessage)
        this.divContainer.appendChild(this.spanArrow)
        return this.divContainer
    }


    async showAsync(errorMessage:string|HTMLElement){
        if(DataTypes.isString(errorMessage)){
            this.spanErrorMessage.textContent = errorMessage as string
        } else {
            this.spanErrorMessage.textContent = ''
            await DomeManipulator.removeAllChildrenAsync(this.spanErrorMessage)
            this.spanErrorMessage.appendChild(errorMessage as HTMLElement)
        }
        this.divContainer.style.display = 'block'
        this.divContainer.classList.add(cssAnimation.zoomIn200)
        this.isVisible = true
    }

    async hideAsync(){
        if(!this.isVisible) return
        this.divContainer.classList.remove(cssAnimation.zoomIn200)
        this.divContainer.classList.add(cssAnimation.zoomOut200)
        await Async.waitMsAsync(200)
        this.divContainer.classList.remove(cssAnimation.zoomOut200)
        this.divContainer.style.display = 'none'
    }
    

}